(function () {
  const TAP_MEDIA = '(max-width: 767px), (hover: none)';

  function usesTapReveal() {
    return window.matchMedia(TAP_MEDIA).matches;
  }

  function initHeroGridWrap(wrap) {
    if (!wrap || wrap.dataset.heroGridInit === 'true') return;
    wrap.dataset.heroGridInit = 'true';

    const cells = wrap.querySelectorAll('.hero-cell--has-hover');
    if (!cells.length) return;

    const closeAll = () => {
      cells.forEach((cell) => cell.classList.remove('hero-cell--active'));
    };

    cells.forEach((cell) => {
      cell.addEventListener('click', (event) => {
        if (!usesTapReveal()) return;

        if (!cell.classList.contains('hero-cell--active')) {
          event.preventDefault();
          closeAll();
          cell.classList.add('hero-cell--active');
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!usesTapReveal()) return;
      if (!event.target.closest('.hero-cell--has-hover')) {
        closeAll();
      }
    });

    window.addEventListener('resize', () => {
      if (!usesTapReveal()) closeAll();
    });
  }

  function initAll() {
    document.querySelectorAll('.hero-grid-wrap').forEach(initHeroGridWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const wrap = event.target.querySelector('.hero-grid-wrap');
    if (wrap) initHeroGridWrap(wrap);
  });
})();
